import { createTypes } from 'redux-compose-reducer';
import { get, post, put } from 'utils/apiRequester';
import { authError } from './auth';


export const TYPES = createTypes('chat', [
  'getMessages',
  'receiveMessages',
  'receiveSignals',
  'sendMessage',
  'getProfileData',
  'wipeChatData'
]);


export function getMessages(dispatch, history, uuid, pagination, filters) {
  const { current, pageSize } = pagination;
  const offset = current * pageSize;
  let url = `/api/chat/conversation/${uuid}/${offset}/${pageSize}`;

  return post(`/api/chat/conversation/read/${uuid}`)
    .then(() => {
      return get(url)
        .then(({ data }) => {

          return dispatch({
            type: TYPES.getMessages,
            data,
            pagination,
            uuid
          });
        });
    })
    .catch(err => authError(dispatch, err, history));
}


export function sendMessage(dispatch, history, conversationUUID, data) {
  return post(`/api/chat/conversation/read/${conversationUUID}`)
    .then(() => {
      return dispatch({
        type: TYPES.sendMessage,
        data: data,
        conversationUUID: conversationUUID
      });
    })
    .catch(err => authError(dispatch, err, history));

}


export function receiveMessages(dispatch, history, conversationUUID, data) {
  return post(`/api/chat/conversation/read/${conversationUUID}`)
    .then(() => {
      return dispatch({
        type: TYPES.receiveMessages,
        data: data,
        conversationUUID: conversationUUID
      });
    })
    .catch(err => authError(dispatch, err, history));
}


export function receiveSignals(dispatch, history, socket, conversationUUID) {
  return dispatch({
    type: TYPES.receiveSignals,
    conversationUUID: conversationUUID
  });
}


export function getProfileData(dispatch, history, uuid, email) {
  let maropostData = null;
  return get(`/api/user/maropost/${email}`)
    .then(({ data }) => {
      maropostData = data;
      return get(`/api/user/non-psychic/profile/${uuid}`);
    })
    .then(({ data }) => {
      data.maropostData = maropostData;
      return dispatch({
        type: TYPES.getProfileData,
        data
      });
    })
    .catch(err => authError(dispatch, err, history));
}


export function wipeChatData(dispatch) {
  return dispatch({
    type: TYPES.wipeChatData
  });
}



// WEBPACK FOOTER //
// ./src/actions/chat.js